<template>
  <div>
    <v-card min-height="550">
      <v-dialog
        v-model="deleteWarningDialog"
        transition="dialog-top-transition"
        max-width="500"
      >
        <template>
          <v-card rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Warning
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon
                class="white--text"
                @click="deleteWarningDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text
              class="black--text pt-5 text-center"
              style="font-size: 20px"
            >
              <span> Are you sure ? </span>
            </v-card-text>
            <v-card-text
              class="black--text text-center"
              style="font-size: 14px"
            >
              Do you really want to delete this record ?
              <p class="mb-0">This process cannot be undone.</p>
            </v-card-text>
            <div class="mx-4">
              <v-divider></v-divider>
            </div>
            <v-card-actions class="px-4 py-5 justify-center">
              <div>
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  class="mr-2 px-5"
                  right
                  height="44"
                  depressed
                  color="primary"
                  style="font-weight: 600"
                  @click="deleteWarningDialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  @click="deleteRecord"
                  right
                  height="44"
                  color="error"
                  class="px-5"
                  style="font-weight: 600"
                >
                  Delete
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
      <v-dialog v-model="calvingFormDialog" max-width="876px">
        <v-form
          ref="calvingForm"
          v-model="calvingFormValid"
          lazy-validation
          @submit.prevent="submitCalvingForm"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div v-if="isEdit && tableEdit">Edit Current Record</div>
              <div v-else-if="isEdit">Edit Current Record</div>
              <div v-else>Add New Record</div>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeProgenyFormDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col cols="12" v-if="isEdit">
                  <v-card flat color="transparent">
                    <v-toolbar
                      class="bdr secondary2light"
                      :elevation="0"
                      outlined
                    >
                      <v-toolbar-title
                        class="grey--text text--darken-2"
                        style="font-size: 13px"
                      >
                        Do you really want to edit this record ? Your previous
                        records might get affected.
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-card>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Calf ID
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        <span>{{
                          $t("animal.reproductionInfo.tooltip.calfId")
                        }}</span></span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="calvingsFormData.calf_id"
                  ></v-text-field>
                </v-col>

                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Calving Date
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{
                        $t("animal.reproductionInfo.tooltip.lastCalvingDate")
                      }}</span>
                    </v-tooltip></label
                  >
                  <v-menu
                    v-model="calvingDateModel"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="calvingsFormData.calving_date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="calvingDateModel = true"
                        placeholder="Select date"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="calvingsFormData.calving_date"
                      @input="calvingDateModel = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" sm="3">
                  <label class="label"
                    >Calf Birth Weight
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t("animal.reproductionInfo.tooltip.calfBirthWeight")
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    :step="0.01"
                    v-model="calvingsFormData.calving_birth_weight_value"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label">{{ "." }} </label>
                  <v-select
                    outlined
                    placeholder="Select Unit"
                    dense
                    v-model="calvingsFormData.calving_birth_weight_unit"
                    :items="calvingBirthWeightOptions"
                  ></v-select>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Dam Birth Ease
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{
                        $t("animal.reproductionInfo.tooltip.damBirthEase")
                      }}</span>
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Option"
                    dense
                    v-model="calvingsFormData.dam_birth_ease"
                    item-value="id"
                    item-text="value"
                    :items="damBirthEaseOptions"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <label class="label">
                    Breeding Method
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="showBodyConditionScoreDialog = true"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.breedingMethod")
                        }}</span
                      >
                    </v-tooltip>
                  </label>
                  <v-select
                    :items="breedingMethodOptions"
                    item-value="id"
                    item-text="value"
                    outlined
                    dense
                    placeholder="Select options"
                    v-model="calvingsFormData.breeding_method"
                  >
                  </v-select>
                </v-col>

                <v-col cols="6">
                  <label class="label">
                    Status
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="showBodyConditionScoreDialog = true"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.progenyStatus")
                        }}
                      </span>
                    </v-tooltip>
                  </label>
                  <v-select
                    :items="calvingStatusOptions"
                    item-text="value"
                    item-value="id"
                    outlined
                    dense
                    placeholder="Select Options"
                    v-model="calvingsFormData.status"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                outlined
                @click="closeProgenyFormDialog"
              >
                Cancel
              </v-btn>

              <v-btn depressed color="primary" type="submit">
                <span v-if="isEdit">{{ $t("update") }}</span>
                <span v-else>{{ $t("submit") }}</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="offspringFormDialog" max-width="876px">
        <v-form
          ref="offspringForm"
          v-model="offspringValid"
          lazy-validation
          @submit.prevent="submitOffspringForm"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div v-if="isEdit && tableEdit">
                Edit Current Record
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="red" v-bind="attrs" v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{
                    ` Do you really want to edit this record ? Your previous records might get affected.`
                  }}</span>
                </v-tooltip>
              </div>
              <div v-else-if="isEdit">Edit Current Record</div>
              <div v-else>Add New Record</div>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeProgenyFormDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Calf ID
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("animal.reproductionInfo.tooltip.calfId") }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="offspringFormData.calf_id"
                  ></v-text-field>
                </v-col>

                <v-col class="py-0" sm="3">
                  <label class="label"
                    >Birth Weight
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{ $t("animal.reproductionInfo.tooltip.birthWeight") }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    :step="0.01"
                    v-model="offspringFormData.birth_weight_value"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label">{{ "." }} </label>
                  <v-select
                    outlined
                    placeholder="Select Taste"
                    dense
                    v-model="offspringFormData.birth_weight_unit"
                    :items="calvingBirthWeightOptions"
                  ></v-select>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Birth Date
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("animal.reproductionInfo.tooltip.birthDate") }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-menu
                    v-model="offspringDateModel"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="offspringFormData.birth_date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="offspringDateModel = true"
                        placeholder="Select date"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="offspringFormData.birth_date"
                      @input="offspringDateModel = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"
                    >Weaning Weight
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.weaningWeight")
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    :step="0.01"
                    v-model="offspringFormData.weaning_weight_value"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label">{{ "." }} </label>
                  <v-select
                    outlined
                    placeholder="Select Taste"
                    dense
                    v-model="offspringFormData.weaning_weight_unit"
                    :items="calvingBirthWeightOptions"
                  ></v-select>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"
                    >Yearling Weight
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t("animal.reproductionInfo.tooltip.yearlingWeight")
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    :step="0.01"
                    v-model="offspringFormData.yearling_weight_value"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"> {{ "." }}</label>
                  <v-select
                    outlined
                    placeholder="Select Units"
                    dense
                    :items="calvingBirthWeightOptions"
                    v-model="offspringFormData.yearling_weight_unit"
                  ></v-select>
                </v-col>

                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Status
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("animal.reproductionInfo.tooltip.status") }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-select
                    :items="calvingStatusOptions"
                    item-text="value"
                    item-value="id"
                    outlined
                    dense
                    placeholder="Select Options"
                    v-model="offspringFormData.status"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                outlined
                @click="closeProgenyFormDialog"
              >
                Cancel
              </v-btn>
              <v-btn depressed color="primary" type="submit"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <div class="d-flex mb-4 align-center">
        <h2>Progeny</h2>
        <v-spacer></v-spacer>
        <div>
          <v-btn
            height="50"
            width="300"
            color="primary"
            outlined
            v-show="!disableCurrentRecordButton"
            @click="startEditGlobal"
            >EDIT CURRENT RECORD</v-btn
          >
        </div>
        <div class="ml-5">
          <div class="d-flex justify-end">
            <v-btn
              height="50"
              width="200"
              @click="startCreate"
              dense
              depressed
              color="primary"
              :disabled="panel == undefined"
              >ADD NEW RECORD</v-btn
            >
          </div>
        </div>
      </div>

      <v-row justify="center">
        <v-row>
          <v-col cols="12" md="4">
            <v-card class="pa-2 green2 elevation-0">
              <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
              <v-list class="green2">
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-subtitle
                      >Average Calving Interval
                      <v-tooltip top color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span
                          >Automatically calculated its time period between two
                          calvings. If more than two calvings , average will be
                          taken</span
                        >
                      </v-tooltip>
                    </v-list-item-subtitle>
                    <v-list-item-title class="text-h6 mt-2">
                      {{ averageCalvingInterval || "Not Specified" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>

        <v-expansion-panels
          class="mt-5"
          style="max-width: 97.5%"
          flat
          v-model="panel"
        >
          <v-expansion-panel>
            <v-expansion-panel-header class="subtitle-1">
              <span>Calving Record</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row width="100%">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Calf ID
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("animal.reproductionInfo.tooltip.calfId")
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentCalvingRecordData &&
                              currentCalvingRecordData.calf_id
                                ? currentCalvingRecordData.calf_id
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Calving Date
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.lastCalvingDate"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentCalvingRecordData &&
                              currentCalvingRecordData.calving_date
                                ? formatDate(
                                    currentCalvingRecordData.calving_date,
                                    "DD/MM/YYYY"
                                  )
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Calf Birth Weight
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.calfBirthWeight"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentCalvingRecordData &&
                              currentCalvingRecordData.calving_birth_weight_value
                                ? currentCalvingRecordData.calving_birth_weight_value
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Dam Birth Ease
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.damBirthEase"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentCalvingRecordData &&
                              currentCalvingRecordData.dam_birth_ease
                                ? getDamBirthEase(currentCalvingRecordData)
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Breeding Method
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.breedingMethod"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentCalvingRecordData &&
                              currentCalvingRecordData.breeding_method
                                ? getBreedingMethod(currentCalvingRecordData)
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Status
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>
                                {{
                                  $t(
                                    "animal.reproductionInfo.tooltip.progenyStatus"
                                  )
                                }}</span
                              >
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentCalvingRecordData &&
                              currentCalvingRecordData.status
                                ? currentCalvingRecordData.status
                                  ? "Active"
                                  : "InActive"
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
              <div>
                <label class="mt-5">Calving Record History</label>
                <v-data-table
                  class="mt-5 rounded-xl"
                  :headers="calvingHeaders"
                  :items="calvingRecordData"
                  :items-per-page="20"
                  hide-default-footer
                  :loading="loading"
                  loading-text="Loading Data..."
                >
                  <template v-slot:item.createdAt="{ item }">
                    <div>
                      {{ item.createdAt | formatDate }}
                    </div>
                  </template>
                  <template v-slot:item.calving_date="{ item }">
                    <div>
                      {{ item.calving_date | formatDate }}
                    </div>
                  </template>
                  <template v-slot:item.dam_birth_ease="{ item }">
                    <div>
                      {{ getDamBirthEase(item) }}
                    </div>
                  </template>
                  <template v-slot:item.breeding_method="{ item }">
                    <div>
                      {{ getBreedingMethod(item) }}
                    </div>
                  </template>
                  <template v-slot:item.status="{ item }">
                    <div>
                      {{ item.status ? "Active" : "Inactive" }}
                    </div>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <div>
                      <v-row>
                        <v-col sm="6">
                          <v-icon
                            dark
                            color="gray"
                            @click="
                              startEdit(item);
                              tableEdit = true;
                            "
                          >
                            mdi-pencil
                          </v-icon>
                        </v-col>
                        <v-col sm="6">
                          <v-icon dark color="red" @click="startDelete(item)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                  <template v-slot:footer></template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="subtitle-1">
              <span>Offspring Record</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="align-center">
              <v-row width="100%" v-if="offspringRecordData.length <= 0">
                <v-col cols="12">
                  <v-card>
                    <div
                      class="d-flex flex-column align-center justify-center"
                      style="
                        width: 100%;
                        height: 183px;
                        flex-shrink: 0;
                        fill: #fff;
                        stroke-width: 1px;
                        stroke: rgba(0, 0, 0, 0.2);
                      "
                    >
                      <span
                        style="
                          font-size: 18px;
                          font-style: normal;
                          font-weight: 600;
                          line-height: 22px;
                        "
                        >No record found</span
                      ><br />
                      <v-btn
                        rounded
                        color="primary"
                        width="239"
                        height="38"
                        @click="startCreate"
                      >
                        ADD New Record
                      </v-btn>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <div v-else>
                <v-data-table
                  class="mt-5 rounded-xl"
                  :headers="offspringHeaders"
                  :items="offspringRecordData"
                  :items-per-page="20"
                  hide-default-footer
                  :loading="loading"
                  loading-text="Loading Data..."
                >
                  <template v-slot:item.birth_date="{ item }">
                    <div>
                      {{ item.birth_date | formatDate }}
                    </div>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <div>
                      <v-row>
                        <v-col sm="6">
                          <v-icon
                            dark
                            color="gray"
                            @click="
                              startEdit(item);
                              tableEdit = true;
                            "
                          >
                            mdi-pencil
                          </v-icon>
                        </v-col>
                        <v-col sm="6">
                          <v-icon dark color="red" @click="startDelete(item)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                  <template v-slot:footer></template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import loading from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import {
  getCalvingRecordByAnimalId,
  createCalvingRecord,
  updateCalvingRecord,
  getOffspringRecordByAnimalId,
  createOffspringsRecord,
  updateOffspringsRecord,
  deleteCalvingRecordById,
  deleteOffspringRecordById,
} from "@/graphql/Reproduction.gql";

export default {
  apollo: {
    getCalvingRecordByAnimalId: {
      query: getCalvingRecordByAnimalId,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentCalvingRecordData =
            data.getCalvingRecordByAnimalId[0] || null;
          this.calvingRecordData = data.getCalvingRecordByAnimalId;
        }
      },
      update: (data) => {
        console.log(data);
      },
      error: (err) =>
        this.$notify({
          title: "Error loading data!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },

    getOffspringRecordByAnimalId: {
      query: getOffspringRecordByAnimalId,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentOffspringRecordData =
            data.getOffspringRecordByAnimalId[0] || null;
          this.offspringRecordData = data.getOffspringRecordByAnimalId;
        }
      },
      update: (data) => {
        console.log(data);
      },
      error: (err) =>
        this.$notify({
          title: "Error loading data!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },
  },
  created() {
    console.log("treatment");
  },
  mixins: [generalMixin, loading],
  data() {
    return {
      calvingDateModel: false,
      offspringDateModel: false,
      loading: false,
      tableEdit: false,
      currentEditItem: null,
      editDialog: false,
      offspringValid: false,
      calvingFormValid: false,
      offspringFormDialog: false,
      calvingFormDialog: false,
      deleteWarningDialog: false,
      calvingHeaders: [
        {
          text: "Calf ID",
          align: "start",
          sortable: true,
          value: "calf_id",
        },
        {
          text: "Calving Date",
          align: "start",
          sortable: true,
          value: "calving_date",
        },
        {
          text: "Calf Birth Weight",
          align: "start",
          sortable: true,
          value: "calving_birth_weight_value",
        },
        {
          text: "Dam Birth Ease",
          align: "start",
          sortable: true,
          value: "dam_birth_ease",
        },
        {
          text: "Breeding Method",
          align: "start",
          sortable: true,
          value: "breeding_method",
        },
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "status",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      offspringHeaders: [
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: "Birth Weight",
          align: "start",
          sortable: true,
          value: "birth_weight_value",
        },
        {
          text: "Birth Date",
          align: "start",
          sortable: true,
          value: "birth_date",
        },
        {
          text: "Weaning Weight",
          align: "start",
          sortable: true,
          value: "weaning_weight_value",
        },
        {
          text: "Yearling Weight",
          align: "start",
          sortable: true,
          value: "yearling_weight_value",
        },
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "status",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],

      calvingsFormData: {},
      offspringFormData: {},
      panel: 0,
      isEdit: false,

      calvingRecordData: [],
      offspringRecordData: [],
      currentCalvingRecordData: null,
      currentOffspringRecordData: null,
    };
  },
  methods: {
    getDamBirthEase(item) {
      let damBirthData = this.damBirthEaseOptions.find(
        (data) => data.id == item.dam_birth_ease
      );
      return damBirthData.value ?? "Not-specified";
    },
    getBreedingMethod(item) {
      let breedingMethodData = this.breedingMethodOptions.find(
        (data) => data.id == item.breeding_method
      );
      return breedingMethodData.value ?? "Not-specified";
    },
    acidityResult(data) {
      if (5.1 <= data && data <= 6.7) {
        return "Low";
      } else if (6.8 <= data && data <= 7) {
        return "Normal";
      } else if (data > 7.1) {
        return "High";
      } else {
        return "N/A";
      }
    },
    specificGravityResult(data) {
      if (1 <= data && data <= 1.02) {
        return "Low";
      } else if (1.021 <= data && data <= 1.03) {
        return "Normal";
      } else if (data > 1.031) {
        return "High";
      } else {
        return "N/A";
      }
    },
    getEditRecord() {
      if (this.panel == 0) {
        return this.currentMilkRecord || this.calvingRecordData[0];
      } else if (this.panel == 1) {
        return this.currentPhysioRecord || this.physioRecordData[0];
      } else if (this.panel == 2) {
        return this.currentMicroRecord || this.microRecordData[0];
      }
    },
    openMicroDialog(dialogCode) {
      this.isMicroDialog = true;
      this.microDialogCode = dialogCode;
    },
    openPhysioDialog(
      dialogCode,
      acidityRawMilkOrGravityValue,
      acidityRawMilkOrGravityResult
    ) {
      this.isPhysioDialog = true;
      this.physioDialogCode = dialogCode;
      this.acidityRawMilkOrGravityValue = acidityRawMilkOrGravityValue;
      this.acidityRawMilkOrGravityResult = acidityRawMilkOrGravityResult;
    },
    closeEditConfirmation() {
      this.editDialog = false;
    },

    async deleteRecord() {
      if (this.panel == 0) {
        this.startLoading();
        try {
          await this.$apollo.mutate({
            mutation: deleteCalvingRecordById,
            variables: {
              id: Number(this.calvingsFormData.id),
            },
          });
          this.$notify({
            title: `Record deleted successfully`,
            type: "success",
            position: "top right",
          });
          this.deleteWarningDialog = false;
          this.$apollo.queries.getCalvingRecordByAnimalId.refetch();
          this.currentCalvingRecordData = await this.calvingRecordData[0];
        } catch (error) {
          this.stopLoading();
        }
        this.stopLoading();
      } else if (this.panel == 1) {
        this.startLoading();
        try {
          await this.$apollo.mutate({
            mutation: deleteOffspringRecordById,
            variables: {
              id: Number(this.offspringFormData.id),
            },
          });
          this.$apollo.queries.getOffspringRecordByAnimalId.refetch();
          this.deleteWarningDialog = false;
          this.currentCalvingRecordData = await this.offspringRecordData[0];
          this.$notify({
            title: `Record Deleted Successfully`,
            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
        }
        this.stopLoading();
      }
    },
    startEditGlobal() {
      this.editDialog = false;
      this.calvingFormDialog = true;
      this.calvingsFormData = this.currentCalvingRecordData;
      if (this.panel == 0) {
        this.isEdit = true;
      }
    },
    startEdit(item) {
      this.editDialog = false;
      this.calvingsFormData.calving_birth_weight_value = Number(
        this.calvingsFormData.calving_birth_weight_value
      );
      if (this.panel == 0) {
        this.isEdit = true;
        this.currentCalvingRecordData = item || this.calvingRecordData[0];
        this.calvingsFormData.id = Number(this.calvingsFormData.id);
        this.calvingsFormData = this.currentCalvingRecordData;
        this.calvingsFormData.calving_date = this.currentCalvingRecordData
          ?.calving_date
          ? moment(this.currentCalvingRecordData?.calving_date).format(
              "YYYY-MM-DD"
            )
          : null;
        this.calvingFormDialog = true;
      } else if (this.panel == 1) {
        this.isEdit = true;
        this.currentOffspringRecordData = item || this.offspringRecordData[0];
        this.offspringFormData = this.currentOffspringRecordData;
        this.offspringFormData.birth_date = this.currentOffspringRecordData
          ?.birth_date
          ? moment(this.currentOffspringRecordData?.birth_date).format(
              "YYYY-MM-DD"
            )
          : null;
        // this.milkEditData = item || this.calvingRecordData[0];

        this.offspringFormDialog = true;
      }
    },

    startDelete(item) {
      if (this.panel == 0) {
        this.calvingsFormData = item;
        this.deleteWarningDialog = true;
      } else if (this.panel == 1) {
        this.offspringFormData = item;
        this.deleteWarningDialog = true;
      }
    },
    startCreate() {
      if (this.panel == 0) {
        this.isEdit = false;
        this.calvingsFormData = {};
        this.calvingFormDialog = true;
      } else if (this.panel == 1) {
        this.isEdit = false;
        this.offspringFormData = {};
        this.offspringFormDialog = true;
      }
    },
    closeProgenyFormDialog() {
      this.calvingFormDialog = false;
      this.calvingsFormData = {};
      this.offspringFormDialog = false;
      this.offspringFormData = {};
    },
    async submitCalvingForm() {
      if (Object.keys(this.calvingsFormData).length == 0) {
        this.$notify({
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.calvingsFormData.animalId = Number(this.$route.params.animal_number);
      this.calvingsFormData.calf_id = Number(this.calvingsFormData.calf_id);
      this.calvingsFormData.calving_birth_weight_value = Number(
        this.calvingsFormData.calving_birth_weight_value
      );
      this.calvingsFormData.status = true;

      this.startLoading();
      if (this.isEdit) {
        delete this.calvingsFormData.userId;
        delete this.calvingsFormData.__typename;
        delete this.calvingsFormData.is_deleted;
        this.calvingsFormData.id = Number(this.calvingsFormData.id);
        console.log(this.calvingsFormData);
        try {
          await this.$apollo.mutate({
            mutation: updateCalvingRecord,
            variables: {
              recordId: this.calvingsFormData.id,
              calvingRecordInput: this.calvingsFormData,
            },
          });
          this.$notify({
            title: `Data updated successfully`,
            type: "success",
            position: "top right",
          });

          this.calvingFormDialog = false;
          this.$apollo.queries.getCalvingRecordByAnimalId.refetch();
          this.currentCalvingRecordData = this.calvingRecordData[0];
        } catch (e) {
          this.stopLoading();
          this.closeProgenyFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      } else {
        try {
          await this.$apollo.mutate({
            mutation: createCalvingRecord,
            variables: {
              calvingRecordInput: this.calvingsFormData,
            },
          });
          this.$notify({
            title: `Data added successfully`,
            type: "success",
            position: "top right",
          });
          this.calvingFormDialog = false;
          this.$apollo.queries.getCalvingRecordByAnimalId.refetch();
          this.currentCalvingRecordData = this.calvingRecordData[0];
        } catch (e) {
          this.stopLoading();
          this.closeProgenyFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      }

      this.stopLoading();
    },
    async submitOffspringForm() {
      this.offspringFormData.animalId = Number(
        this.$route.params.animal_number
      );
      this.offspringFormData.calf_id = Number(this.offspringFormData.calf_id);
      this.offspringFormData.birth_weight_value = Number(
        this.offspringFormData.birth_weight_value
      );
      this.offspringFormData.weaning_weight_value = Number(
        this.offspringFormData.weaning_weight_value
      );
      this.offspringFormData.yearling_weight_value = Number(
        this.offspringFormData.yearling_weight_value
      );
      if (Object.keys(this.offspringFormData).length == 0) {
        this.$notify({
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.startLoading();
      if (this.isEdit) {
        try {
          this.offspringFormData.id = Number(this.offspringFormData.id);
          delete this.offspringFormData.userId;
          delete this.offspringFormData.__typename;
          delete this.offspringFormData.is_deleted;
          let formData = {
            ...this.offspringFormData,
          };

          await this.$apollo.mutate({
            mutation: updateOffspringsRecord,
            variables: {
              recordId: Number(this.offspringFormData.id),
              offspringRecordInput: formData,
            },
          });
          this.closeProgenyFormDialog();
          await this.$apollo.queries.getOffspringRecordByAnimalId.refetch();
          this.$notify({
            title: `Offspring Record Updated Successfully`,
            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
          this.closeProgenyFormDialog();
        }
      } else {
        try {
          await this.$apollo.mutate({
            // Query
            mutation: createOffspringsRecord,
            // Parameters
            variables: {
              offspringRecordInput: this.offspringFormData,
            },
          });
          this.closeProgenyFormDialog();

          await this.$apollo.queries.getOffspringRecordByAnimalId.refetch();
          this.$notify({
            title: `Offspring Record created  Successfully`,

            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
          this.closeProgenyFormDialog();
        }
      }

      this.stopLoading();
    },
  },
  computed: {
    ...mapGetters([""]),
    calvingBirthWeightOptions() {
      return ["kg"];
    },
    damBirthEaseOptions() {
      return [
        { id: 1, value: "No assistance" },
        { id: 2, value: "Some assistance" },
        { id: 3, value: "Mechanical assistance" },
        { id: 4, value: "C-section" },
        { id: 5, value: "Abnormal delivery" },
      ];
    },
    breedingMethodOptions() {
      return [
        { id: 1, value: "Natural" },
        { id: 2, value: "Artificial Insemination" },
        { id: 3, value: "Embryo Transfer" },
      ];
    },
    calvingStatusOptions() {
      return [
        { id: true, value: "Active" },
        { id: false, value: "InActive" },
      ];
    },
    disableCurrentRecordButton() {
      if (this.panel == undefined) {
        return true;
      } else if (this.panel == 0 && !this.currentCalvingRecordData) {
        return false;
      } else if (this.panel == 1) {
        return true;
      } else {
        return false;
      }
    },
    acidityRawUnitOptions() {
      return ["pH"];
    },
    specificGravityUnitOptions() {
      return ["° C"];
    },
    snfUnitOptions() {
      return ["%"];
    },
    proteinContentUnitOptions() {
      return ["kg", "lb(s)", "liter(s)"];
    },
    fatContentUnitOptions() {
      return ["%"];
    },
    milkYieldUnitOptions() {
      return ["kg", "lb(s)", "liter(s)"];
    },
    proteinYieldUnitOptions() {
      return ["kg", "lb(s)"];
    },
    milkLactoseUnitOptions() {
      return ["%"];
    },
    milkUreaUnitOptions() {
      return ["mg", "dl"];
    },
    milkColorOptions() {
      return [
        "Yellow",
        "Cream White",
        "White with Flakes",
        "Yellow with Flakes",
        "Red",
        "Other",
      ];
    },
    milkTasteOptions() {
      return [
        "Slightly Sweet",
        "Sour",
        "Soapy Bitter/Rancid Flavour",
        "Metallic/Cardboardy",
        "Feed Flavor",
        "Fermented",
        "Putrid Malty Flavor",
        "Cowy",
        "Nutty",
        "Salty",
      ];
    },
    milkSmellOptions() {
      return [
        "No Smell",
        "Odor",
        "Rotten",
        "Smell",
        "Fishy off-Flavour",
        "Rancid Odor",
        "Other",
      ];
    },
    locationNumberOptions() {
      return [1, 2, 3, 4, 5];
    },
    locationLengthOptions() {
      return [1, 2, 3, 4, 5];
    },
    locationLengthUnitOptions() {
      return ["days", "weeks", "months", "years"];
    },
    milkFrequencyOptions() {
      return [1, 2, 3, 4, 5];
    },
    somaticCellData() {
      return [
        "100,000 cells/ml",
        "100000-199000",
        "200000-299000",
        "300000-399000",
        ">400000",
      ];
    },

    somaticCellResultData() {
      return {
        "100,000 cells/ml": "Normal",
        "100000-199000": "Required Observation",
        "200000-299000": "Suspected",
        "300000-399000": "Affected",
        ">400000": "Suffering",
      };
    },
    preliminaryIncubationCountData() {
      return ["<100000 cfu/ml", "10,000-50000 cfu/ml", ">50,000 cfu/ml"];
    },
    preliminaryIncubationResultData() {
      return {
        "<100000 cfu/ml": "Ideal",
        "10,000-50000 cfu/ml": "Acceptable",
        ">50,000 cfu/ml": "Concerned",
      };
    },
    viableCountData() {
      return ["<5000", "5000-10000", ">10,000"];
    },
    viableCountResultData() {
      return {
        "<5000": "Recommended",
        "5000-10000": "Medium",
        ">10,000": "High",
      };
    },

    coliformCountData() {
      return ["<50", "50-100", ">10,000"];
    },
    coliformCountResultData() {
      return { "<50": "Recommended", "50-100": "Medium", ">10,000": "High" };
    },
    yeastMouldCountData() {
      return ["<30", "30-50", ">50"];
    },
    yeastMouldResultData() {
      return {
        "<30": "Acceptable",
        "30-50": "Satisfactory Quality",
        ">50": "Affected",
      };
    },
    antiMicrobialData() {
      return ["Negative", "Positive"];
    },
    sortedCalvingRecords() {
      return this.calvingRecordData
        .slice()
        .sort((a, b) => moment(a.calving_date).diff(moment(b.calving_date)));
    },
    averageCalvingInterval() {
      if (this.sortedCalvingRecords.length === 2) {
        // If there are exactly two calving records, show the interval between them
        const date1 = moment(this.sortedCalvingRecords[0].calving_date);
        const date2 = moment(this.sortedCalvingRecords[1].calving_date);
        const interval = date2.diff(date1, "days");
        return `${interval} days`;
      } else if (this.sortedCalvingRecords.length > 2) {
        // If there are more than two calving records, calculate and show the average interval
        const timeIntervals = [];
        for (let i = 1; i < this.sortedCalvingRecords.length; i++) {
          const date1 = moment(this.sortedCalvingRecords[i - 1].calving_date);
          const date2 = moment(this.sortedCalvingRecords[i].calving_date);
          const timeInterval = date2.diff(date1, "days");
          timeIntervals.push(timeInterval);
        }
        console.log(timeIntervals);
        const averageInterval =
          timeIntervals.reduce((sum, interval) => sum + interval, 0) /
          timeIntervals.length;
        return `${averageInterval.toFixed(2)} days`;
      } else {
        return "Not Specified";
      }
    },
  },
  mounted() {
    this.panel = 0;
  },
  watch: {
    refreshProp() {
      this.panel = 0;
    },
  },
  props: ["treatment", "refreshProp"],
};
</script>

<style lang="scss" scoped>
.v-expansion-panel {
  margin-top: 10px;
}
.v-expansion-panel-header {
  background: #f3f3f380;
  border-radius: 5px;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}

.card-border-content {
  color: var(--Secondary-1, #00bd73);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.7px;
}
.card-border-content-pointer {
  cursor: pointer;
}
</style>
